export const OwnDeliveryStatusEnum = {
    VALIDATED_OBJECT: {
        title: "Expedido",
        description: "Pedido expedido",
        id: 3,
        order: 1
    },
    OBJECT_POSTED: {
        title: "Objeto postado",
        description: "Objeto postado",
        id: 18,
        order: 2
    },
    OBJECT_IN_TRANSIT: {
        title: "Em trânsito",
        description: "Objeto em trânsito",
        id: 4,
        order: 3
    },
    START_ROUTE: {
        title: "Objeto saiu para entrega",
        description: "Objeto saiu para entrega",
        id: 5,
        order: 4
    },
};

export const OwnDeliveryStatusEnumArray = Object.values(OwnDeliveryStatusEnum).map((status) => ({
    ...status,
}));

export const trackingEventById = (id) => {
    if (!id) return null;

    return OwnDeliveryStatusEnumArray.find((status) => status.id === id);
};
